package com.essntl.features.itinerary.domain.model

data class ItineraryFilterOptions(
    val searchText: String = "",
    val selectedItineraryOrderType: ItineraryOrderType = ItineraryOrderType.Default,
    val selectedFromDate: String = "",
    val selectedToDate: String = "",
    val selectedProfileIds: Set<String> = emptySet(),
    val completed: Boolean = false,
)
